/* eslint-disable no-console */
import React from 'react';

const Contact = () => (
  <div>
    <div className="menu-nav-item">Contact</div>
    <p>
      jef.a.mayer(at)gmail.com
      <br />
      <a className="inline-link" href="https://jefmayer.com">jefmayer.com</a>
    </p>
  </div>
);

export default Contact;
/* eslint-enable no-console */
